import type { CSSProperties } from 'react';
import type { PlayerRace } from '@kaeliux/shared';

export const RACE_ACCENT_VAR: Record<PlayerRace, string> = {
    humans: 'var(--race-humans)',
    robots: 'var(--race-robots)',
    axons: 'var(--race-axons)',
};

export function raceAccentStyle(race: PlayerRace): CSSProperties {
    return { '--race-accent': RACE_ACCENT_VAR[race] } as CSSProperties;
}

export const RACE_BG_TINT: Record<PlayerRace, string> = {
    humans: 'color-mix(in oklch, var(--race-humans) 8%, transparent)',
    robots: 'color-mix(in oklch, var(--race-robots) 8%, transparent)',
    axons: 'color-mix(in oklch, var(--race-axons) 8%, transparent)',
};
